<script setup>
import { modelTables } from 'src/models'
import Breadcrumbs from 'src/modules/admin/components/Breadcrumbs'
import { computed, getCurrentInstance, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const vm = getCurrentInstance()
const trackPage = vm.appContext.config.globalProperties.$trackPage

const props = defineProps({
  modelName: {
    type: String,
    required: false,
    default: null
  }
})

const route = useRoute()
const component = computed(() => modelTables[props.modelName || route.params.name])
const componentRef = ref(null)
const loading = ref(false)

watch(componentRef, () => {
  if (componentRef.value) {
    trackPage(componentRef.value)
  }
})
</script>

<template>
  <q-page class="q-pa-sm model-index-page">
    <q-inner-loading :showing="loading" />
    <breadcrumbs />
    <component
      :is="component"
      ref="componentRef"
      enable-query-encodable-options
      @vue:mounted="loading = false"
    />
  </q-page>
</template>

<style scoped>
.model-index-page {
  /* enough space for bottom Intercom floating action button to not block pagination */
  margin-bottom: 54px;
}
</style>
